import {RouterView} from '@/routes/RouterView.js';
const UnreadMessages = _ => import(/* WebpackChunkName: "js/split/UnreadMessages", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/UnreadMessages');
const MessageHistory = _ => import(/* webpackChunkName: "js/split/MessageHistory", webpackPreload: true */'@/components/views/home/young/relatioshipYoungToAdvisor/partials/MessageHistory');

const Company = _ => import(
	/* webpackChunkName: "js/split/Company", webpackPreload: true */
	'@/components/views/home/advisor/company/partials/Company');


export default {
	path: '/correos/',
	component: RouterView,
	children: [
		/* {
			path: 'index',
			component:  Company,
			name: 'Company',
			meta:{
				auth: true
			}
		}, */
        {
            path: 'mensajes-no-leidos',
            component: UnreadMessages,
            name:'UnreadMessages',
            meta:{
                auth:true,
                //haveARelationshipWithCompany : true,
                //requiredProfile: [2]
            }
        },
        {
            path: 'historico-de-mensajes',
            component: MessageHistory,
            name:'MessageHistory',
            meta:{
                auth:true,
                //haveARelationshipWithCompany : true,
                //requiredProfile: [2]
            }
        },
	],

}